import React from 'react';

export function Camera() {
  return null;
}

Camera.getCameraPermissionStatus = async () => 'denied';
Camera.requestCameraPermission = async () => 'denied';

export function useCameraDevice() {
  return undefined;
}

export function useCameraPermission() {
  return {hasPermission: false, requestPermission: async () => false};
}

export function useCodeScanner(options) {
  return options;
}

export function useFrameProcessor(processor) {
  return processor;
}
